module.exports = __webpack_public_path__ + "static/media/car-3956530_640.15ae09dd.jpg";